<div class="uls">
  <div class="ul-card" [class]="size()" [style]="dialogCardStyles()">
    <comp-dialog-header [showCloseIcon]="showCloseIcon()" [closeIconValue]="closeIconValue()">
      <ng-container comp-dialog-header-inner-title>
        <ng-content select="[comp-dialog-header-title]"></ng-content>
      </ng-container>
      <ng-container comp-dialog-header-inner-subtitle>
        <ng-content select="[comp-dialog-header-subtitle]"></ng-content>
      </ng-container>
      <ng-container comp-dialog-header-inner-action-items>
        <ng-content select="[comp-dialog-header-action-items]"></ng-content>
      </ng-container>
    </comp-dialog-header>
    <comp-dialog-content>
      <ng-container comp-dialog-content-inner>
        <ng-content select="[comp-dialog-content]"></ng-content>
      </ng-container>
    </comp-dialog-content>
    <comp-dialog-footer>
      <ng-container comp-dialog-footer-inner>
        <ng-content select="[comp-dialog-footer]"></ng-content>
      </ng-container>
    </comp-dialog-footer>
  </div>
</div>
